import * as React from 'react';
import {StorageSuccessModal} from "../modals/StorageSuccessModal";
import {setCookie} from "./CommonFunctions";

interface IProps {
}

interface IState {
    redirectedAfterPasswordChange: boolean;
}

export class ChangePasswordWidget extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            redirectedAfterPasswordChange: this.getPasswordRedirectSuccessfulPopUp(),
        }

        this.closeSuccessfulPasswordModal = this.closeSuccessfulPasswordModal.bind(this);
    }

    public render(): React.ReactNode {
        return (
            <div>
                <div className="panel-detail-output-entity account-details-title p-0">
                    <h2 className="inner-content dashboard-panel-title">Password</h2>
                </div>
                <div className="form-group">
                    <a id="changePasswordLink"
                        onClick={ChangePasswordWidget.setRedirectCookieForPasswordChange}
                        href={`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/auth?client_id=${process.env.REACT_APP_KEYCLOAK_CLIENT_ID}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=openid&kc_action=UPDATE_PASSWORD`}
                        className="buttonLink">
                        <button type="button"
                                className={"btn btn-white-dashboard m-auto"}>
                            Change password
                        </button>
                    </a>
                </div>
                {this.state.redirectedAfterPasswordChange &&
                    <StorageSuccessModal
                        title="All done!"
                        explanationWording={<p>Your password has been changed and saved</p>}
                        onClose={this.closeSuccessfulPasswordModal}
                    />
                }
            </div>
        )
    }

    private static setRedirectCookieForPasswordChange(): void {
        setCookie("redirectPage", document.URL);
    }

    private closeSuccessfulPasswordModal(): void {
        this.setState({
            redirectedAfterPasswordChange: false
        })
    }

    private getPasswordRedirectSuccessfulPopUp(): boolean {
        const redirected = document.cookie.search("passwordSuccessfullyChanged") !== -1;
        document.cookie = 'passwordSuccessfullyChanged=true; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';
        return redirected;
    }
}



// WEBPACK FOOTER //
// ./src/components/accountDetails/ChangePasswordWidget.tsx